import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    constructor(private oidcSecurityService: OidcSecurityService) {}

    ngOnInit(): void {
        // If an OIDC callback is being processed (URL still has code/state),
        // don't re-initiate a new authorize() — APP_INITIALIZER's checkAuth()
        // is consuming the round-trip. Starting a second authorize here would
        // overwrite the stored state and cause "could not find matching config".
        const search = window.location.search;
        if (search.indexOf('code=') !== -1 || search.indexOf('state=') !== -1) {
            return;
        }

        this.oidcSecurityService.authorize(undefined, {
            customParams: { prompt: 'select_account' }
        });
    }
}
